import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

interface StoreRegistrationDialogProps {
  open: boolean;
  storeName: string;
  onConfirm: () => Promise<{ success: boolean; error?: string }>;
  onCancel: () => void;
}

const StoreRegistrationDialog: React.FC<StoreRegistrationDialogProps> = ({
  open,
  storeName,
  onConfirm,
  onCancel,
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleConfirm = async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await onConfirm();
      if (!result.success) {
        setError(result.error || '登録に失敗しました');
      }
    } catch {
      setError('登録中にエラーが発生しました');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={undefined}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 3, p: 1 }
      }}
    >
      <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold', pb: 1 }}>
        店舗登録の確認
      </DialogTitle>
      <DialogContent sx={{ textAlign: 'center' }}>
        <Typography variant="body1" sx={{ mb: 1 }}>
          <strong>{storeName}</strong>
        </Typography>
        <Typography variant="body2" color="text.secondary">
          に登録しますか？
        </Typography>
        {error && (
          <Typography variant="body2" color="error" sx={{ mt: 2 }}>
            {error}
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', gap: 2, pb: 2 }}>
        <Button
          variant="outlined"
          onClick={onCancel}
          disabled={loading}
          sx={{ borderRadius: 6, minWidth: 100 }}
        >
          キャンセル
        </Button>
        <Button
          variant="contained"
          onClick={handleConfirm}
          disabled={loading}
          sx={{ borderRadius: 6, minWidth: 100 }}
        >
          {loading ? <CircularProgress size={20} color="inherit" /> : '登録する'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StoreRegistrationDialog;
